import styled from '@emotion/styled';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import { Link } from 'react-router-dom';

export const WrapperCategories = styled.div`
display: flex;
flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export const StyledTitle = styled('h2')(({ theme }) => `

`);


export const WrapperCategory = styled('div')(({ theme, color }) => `
border: 1px solid ${theme.palette[color].main};
border-radius: 20px;
padding: 10px 20px 20px 20px;
width: 100%;
`);

export const List = styled('ul')(() => `
margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
`);

export const CapitalizeWord = styled.span`
text-transform: capitalize;
`;

export const WrapperDescriptionComingSoon = styled.div`
display: flex;
flex-wrap:wrap;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
`;

export const LinkInsta = styled(Link)(({ theme }) => `
display: flex;
justify-content: center;
align-items: center;
gap: 4px;
color: ${theme.palette.text.primary};
`);

export const IconInsta = styled(InstagramIcon)(({ theme }) => `
color: ${theme.palette.text.accent};
transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1);
&:hover{
         color: ${theme.palette.primary.main};        
  }
`);

export const IconFacebook = styled(FacebookIcon)(({ theme }) => `
color: ${theme.palette.primary.main};
transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1);
&:hover{
         color: ${theme.palette.text.accent};        
  }
`);






